import React from 'react';
import axios from "../../../../containers/api";
import {Button, FormGroup, Input, Label} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../../../helpers/Utils";
import Switch from "rc-switch";
import "rc-switch/assets/index.css";

class AgentAccess extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            agentId: this.props.agentId,
            loadSystemReserve: false,//رزرو سیستمی
            instantBill: false,//صدور بارنامه آنی
            loadSelectedDrivers: false,//فراخوان رانندگان در اعلام بار
            reserveEntrancePermission: false,//مجوز ورود
            insertDraft: false,//صدور حواله
            minLoadReserveRange: "",//حداقل مسافت محدوده رزرو (کیلومتر)
            maxLoadReserveRange: "",//حداکثر مسافت محدوده رزرو (کیلومتر)
        }
    }

    componentDidMount() {
        this.GetAgentPermissions();
        this.GetAgentSettings();
    }

    GetAgentPermissions = () => {
        this.props.showSpinner();
        axios.get('api/AgentPermissionApi/GetAgentPermissions?agentId=' + this.state.agentId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data !== null) {
                    this.setState({
                        loadSystemReserve: res.data.loadSystemReserve,//رزرو سیستمی
                        instantBill: res.data.instantBill,//صدور بارنامه آنی
                        loadSelectedDrivers: res.data.loadSelectedDrivers,//فراخوان رانندگان در اعلام بار
                        reserveEntrancePermission: res.data.reserveEntrancePermission,//مجوز ورود
                        insertDraft: res.data.insertDraft,//صدور حواله
                    });
                } else {
                    this.setState({
                        loadSystemReserve: false,//رزرو سیستمی
                        instantBill: false,//صدور بارنامه آنی
                        loadSelectedDrivers: false,//فراخوان رانندگان در اعلام بار
                        reserveEntrancePermission: false,//مجوز ورود
                        insertDraft: false,//صدور حواله
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    GetAgentSettings = () => {
        this.props.showSpinner();
        axios.get('api/AgentSetingApi/GetAgentSettings?agentId=' + this.state.agentId)
            .then((res) => {
                this.props.hideSpinner();
                if (res.data !== null) {
                    this.setState({
                        minLoadReserveRange: res.data.minLoadReserveRange !== null ? res.data.minLoadReserveRange.valueInt : "",//حداقل مسافت محدوده رزرو (کیلومتر)
                        maxLoadReserveRange: res.data.maxLoadReserveRange !== null ? res.data.maxLoadReserveRange.valueInt : "",//حداکثر مسافت محدوده رزرو (کیلومتر)
                    });
                } else {
                    this.setState({
                        minLoadReserveRange: "",//حداقل مسافت محدوده رزرو (کیلومتر)
                        maxLoadReserveRange: "",//حداکثر مسافت محدوده رزرو (کیلومتر)
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    DenyPermission = (value, Permission) => {
        let APi = "DenyPermission";
        if (value === true) {
            APi = "GrantPermission";
        }

        this.props.showSpinner();
        axios.get('api/AgentPermissionApi/' + APi + '?agentId=' + this.state.agentId + "&type=" + Permission)
            .then((res) => {
                this.props.hideSpinner();
                this.GetAgentPermissions(this.state.agentId);
                this.GetAgentSettings(this.state.agentId);
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    SetAgentSettingMin = () => {
        if (this.state.minLoadReserveRange === null || this.state.minLoadReserveRange === "" || this.state.minLoadReserveRange === undefined) {
            this.props.showAlert('حداقل مسافت محدوده رزرو را وارد کنید', 'error');
        } else {
            const model = {
                AgentID: this.state.agentId,
                ValueInt: toEnglishNumbers(this.state.minLoadReserveRange),
                Name: "MinLoadReserveRange"
            }

            this.props.showSpinner();
            axios.post('api/AgentSetingApi/SetAgentSetting', model)
                .then((res) => {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data, 'success');
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };

    SetAgentSettingMax = () => {
        if (this.state.maxLoadReserveRange === null || this.state.maxLoadReserveRange === "" || this.state.maxLoadReserveRange === undefined) {
            this.props.showAlert('حداکثر مسافت محدوده رزرو را وارد کنید', 'error');
        } else {
            const model = {
                AgentID: this.state.agentId,
                ValueInt: toEnglishNumbers(this.state.maxLoadReserveRange),
                Name: "MaxLoadReserveRange"
            }

            this.props.showSpinner();
            axios.post('api/AgentSetingApi/SetAgentSetting', model)
                .then((res) => {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data, 'success');
                })
                .catch((error) => {
                    this.props.hideSpinner();
                    console.log(error.response);
                    this.props.showAlert(showCatchError(error), "error");
                });
        }
    };

    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-20 w-100 px-1">
                        <Label>فراخوان رانندگان در اعلام بار</Label>
                        <Switch
                            className="custom-switch custom-switch-primary"
                            checked={this.state.loadSelectedDrivers}
                            onChange={(e) => this.DenyPermission(e, "loadSelectedDrivers")}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-20 w-100 px-1">
                        <Label>صدور بارنامه آنی</Label>
                        <Switch
                            className="custom-switch custom-switch-primary"
                            checked={this.state.instantBill}
                            onChange={(e) => this.DenyPermission(e, "instantBill")}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-20 w-100 px-1">
                        <Label>رزرو سیستمی</Label>
                        <Switch
                            className="custom-switch custom-switch-primary"
                            checked={this.state.loadSystemReserve}
                            onChange={(e) => this.DenyPermission(e, "loadSystemReserve")}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-20 w-100 px-1">
                        <Label>مجوز ورود</Label>
                        <Switch
                            className="custom-switch custom-switch-primary"
                            checked={this.state.reserveEntrancePermission}
                            onChange={(e) => this.DenyPermission(e, "reserveEntrancePermission")}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-20 w-100 px-1">
                        <Label>صدور حواله</Label>
                        <Switch
                            className="custom-switch custom-switch-primary"
                            checked={this.state.insertDraft}
                            onChange={(e) => this.DenyPermission(e, "insertDraft")}
                        />
                    </FormGroup>
                </div>

                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>حداقل مسافت محدوده رزرو (کیلومتر)</Label>
                        <Input value={this.state.minLoadReserveRange}
                               onChange={(e) => this.setState({minLoadReserveRange: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1 d-flex align-items-end">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.SetAgentSettingMin()}>
                            ثبت
                        </Button>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>حداکثر مسافت محدوده رزرو (کیلومتر)</Label>
                        <Input value={this.state.maxLoadReserveRange}
                               onChange={(e) => this.setState({maxLoadReserveRange: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1 d-flex align-items-end">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.SetAgentSettingMax()}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>
            </div>
        );
    }
}

export default AgentAccess;